document.addEventListener("DOMContentLoaded", function() {
    const button = document.getElementById('gokwik-buy-now');

    function shakeButton() {
      if (button.classList.contains('pendant-buy')) {
        button.classList.add('shake');
        setTimeout(() => {
          button.classList.remove('shake');
        }, 500); 
      }
    }

    function startShaking() {
      shakeButton(); 
      setTimeout(shakeButton, 500); 
      setTimeout(() => {
        startShaking();
      }, 3500);
    }
    startShaking();
  });